export default "__VITE_ASSET__CKdRV3Uh__"